<template>
  <el-dialog
    ref="printContent"
    id="printBox"
    :title="
      dialogConfig.type == '0'
        ? '新增申请'
        : dialogConfig.type == '1'
        ? '编辑申请'
        : '申请详情'
    "
    v-model="visible"
    width="60%"
    style="overflow: hidden"
    :close-on-click-modal="false"
  >
    <el-collapse
      v-model="activeNames"
      style="overflow-y: auto; height: 55vh"
      v-loading="loading"
    >
      <el-collapse-item title="申请信息" name="baseMsg">
        <el-form
          :model="formData"
          label-width="100px"
          ref="ruleRef"
          :rules="rules"
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="申请单号" prop="number">
                <el-input
                  v-model="formData.number"
                  placeholder="自动获取"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请人：">
                <el-input
                  v-model="userName"
                  placeholder="自动获取"
                  :maxlength="40"
                  v-no-space
                  :disabled="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间" prop="boundTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.boundTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择申请时间"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="申请部门" prop="requestDepartmentId">
                <el-tree-select
                  v-model="formData.requestDepartmentId"
                  :data="orgTree"
                  placeholder="请选择组织"
                  :props="defaultPropsOrg"
                  :show-checkbox="true"
                  :check-strictly="true"
                  node-key="organizationCode"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门负责人" prop="departmentHeadId">
                <el-select
                  v-model="formData.departmentHeadId"
                  style="width: 100%"
                  filterable
                  @change="changeUser"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.nikeName"
                    :value="item.userCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- <el-form-item label="用料时间" prop="useTime">
                <el-date-picker
                  type="datetime"
                  v-model="formData.useTime"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="请选择申请时间"
                />
              </el-form-item> -->
              <el-form-item label="工程类型" prop="projectType">
                <el-select
                  v-model="formData.projectType"
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in projectList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="物料用途" prop="type">
                <el-select
                  v-model="formData.type"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeType"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.dictLabel"
                    :value="String(item.dictValue)"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type === '1'">
              <el-form-item label="维修备注" prop="repairRemark">
                <el-input
                  v-model="formData.repairRemark"
                  placeholder="请输入"
                  type="textarea"
                  :maxlength="200"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="工程来源" prop="thirdResourceType">
                <el-select
                  v-model="formData.thirdResourceType"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeResType"
                >
                  <el-option
                    v-for="item in originList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="工程名称" prop="thirdResourceName">
                <el-select
                  filterable
                  v-model="formData.thirdResourceId"
                  placeholder="请选择"
                  style="width: 100%"
                  @change="changeResName"
                >
                  <el-option
                    v-for="item in thirdResourceList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 2">
              <el-form-item label="工程编号" prop="thirdResourceRef">
                <el-input
                  v-model="formData.thirdResourceRef"
                  placeholder="请输入"
                  :maxlength="40"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="formData.type == 3">
              <el-form-item label="厂站名称" prop="thirdResourceId">
                <el-tree-select
                  v-model="formData.thirdResourceId"
                  :data="factoryStationList"
                  node-key="id"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  @node-click="handleNodeClick"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col>
              <el-form-item label="使用说明： " prop="remark">
                <el-input
                  v-model="formData.remark"
                  type="textarea"
                  :rows="3"
                  :maxlength="200"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="申请人签名">
                <el-input
                  v-model="formData.deliverySign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门负责人签名" label-width="auto">
                <el-input
                  v-model="formData.boundSign"
                  placeholder="请输入"
                  :maxlength="40"
                  v-no-space
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-descriptions border :column="3" v-else>
          <div v-for="item in descriptionList" :key="item.value">
            <el-descriptions-item
              :key="item.value"
              :label="item.label"
              :span="item.span || 1"
              v-if="!item.show || item.show(formData)"
              width="16%"
            >
              <span class="my_class">{{
                formData[item.value] ? formData[item.value] : "-"
              }}</span>
            </el-descriptions-item>
          </div>
        </el-descriptions>
      </el-collapse-item>
      <el-collapse-item title="物料信息" name="materiel">
        <div class="flex">
          <el-text type="primary"></el-text>
          <el-button
            type="primary"
            @click="handleMaterielSelect()"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
            >选择物料</el-button
          >
        </div>
        <el-table
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          class="mt10"
          :data="tableData"
        >
          <el-table-column label="序号" type="index" width="60" fixed />
          <template v-for="item in columns" :key="item.prop">
            <el-table-column
              :label="item.label"
              :prop="item.prop"
              :min-width="120"
              show-overflow-tooltip
            >
              <template #default="{ row, $index }">
                <el-input-number
                  v-if="
                    item.prop == 'warehousePosition' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :controls="false"
                  style="width: 100%"
                  :min="0"
                  :precision="0"
                  :max="99999999"
                />
                <span
                  v-else-if="
                    item.prop == 'warehousePosition' && dialogConfig.type == '2'
                  "
                  >{{ row.warehousePositionName }}</span
                >
                <span
                  v-else-if="
                    item.prop == 'supplier' && dialogConfig.type == '2'
                  "
                  >{{ row.supplierName }}</span
                >
                <span v-else-if="item.prop == 'totalQuantity'">{{
                  row.totalQuantity
                }}</span>
                <el-input
                  v-else-if="
                    item.prop == 'supplier' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  @click="handleSupplierSelect($index)"
                >
                </el-input>
                <el-input-number
                  v-if="
                    item.prop == 'applyQuantity' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  :controls="false"
                  style="width: 100%"
                  :min="0"
                  :precision="4"
                  :max="row.totalQuantity"
                />
                <el-input
                  v-if="
                    item.prop == 'remark' &&
                    (dialogConfig.type == '0' || dialogConfig.type == '1')
                  "
                  v-model="row[item.prop]"
                  style="width: 100%"
                />
                <span
                  v-else-if="item.prop == 'remark' && dialogConfig.type == '2'"
                  >{{ row[item.prop] }}</span
                >
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="操作"
            fixed="right"
            v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          >
            <template #default="{ $index }">
              <el-button type="primary" link @click="handleRemove($index)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          v-if="dialogConfig.type == '2'"
          type="primary"
          @click="print()"
          :disabled="buttonLoading"
        >
          打印
        </el-button>
        <el-button @click="handleCancel()">返回</el-button>
        <el-button
          v-if="dialogConfig.type == '0' || dialogConfig.type == '1'"
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>

    <!-- 物料选择组件 -->
    <MaterielSelectionFromStore
      ref="selectRef"
      type="in"
      @selectDone="materielSelectDone"
    />
    <!-- 供应商选择组件 -->
    <SupplierSelection
      ref="supplierSelectRef"
      type="in"
      @selectDone="supplierSelectionDone"
    />
    <!-- 工程选择组件 -->
    <ProjectSelection
      ref="projectSelectRef"
      type="in"
      @selectDone="ProjectSelectionDone"
    />
    <!-- 文件导入 -->
    <InStorageFileUpload
      ref="uploadRef"
      @afterUpload="afterUpload"
      :fn="uploadExcelData"
      :uploadConfig="uploadConfig"
    />
  </el-dialog>
</template>

<script setup>
import { ElMessage } from "element-plus";
import { reactive, ref } from "vue";
import MaterielSelectionFromStore from "@/components/MaterielSelectionFromStore.vue";
import SupplierSelection from "@/components/SupplierSelection.vue";
import ProjectSelection from "@/components/ProjectSelection.vue";
import useStashList from "../../hooks/useStashList";
import {
  saveAcceptMaterialV164,
  queryDetailById,
  updateAcceptMaterialV164,
  queryProjectList,
  queryInstallList,
} from "@/api/requisition";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import { queryStashById } from "@/api/stash";
import { querySupplierList } from "@/api/supplier";
import axios from "axios";
import InStorageFileUpload from "@/components/InStorageFileUpload.vue";
import useUserList from "../../hooks/useUserList";
import { getFactoryStationList } from "@/api/bound";
import { queryOrganization } from "@/api/organization";
import Print from "@/utils/print";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
//工程来源
const originList = [
  { label: "工程立项", value: "1" },
  { label: "工程报装", value: "3" },
];

//工程名称列表
const thirdResourceList = ref([]);
//组织
const orgTree = ref([]);

// 事件绑定
const emits = defineEmits(["afterSave"]);

// 仓库列表
const { stashList } = useStashList();

// 用户列表
const { userList } = useUserList();

// 申请类型列表
const typeList = ref([]);

// 当前选中的仓库的库位
const locationList = ref([]);

// 供应商列表
const supplierList = ref([]);

// 弹窗控制器
const visible = ref(false);

// 遮罩
const loading = ref(false);

// 表单ref
const ruleRef = ref(null);

// 物料选择ref
const selectRef = ref(null);

//供应商选择ref
const supplierSelectRef = ref(null);

// 项目选择ref
const projectSelectRef = ref(null);

// 保存按钮loading
const buttonLoading = ref(false);

// 弹窗打开接收参数
const dialogConfig = ref({});

// 文件列表
const fileList = ref("");

// 物料列表
const tableData = ref([]);

//文件列表
const tableFileData = ref([]);

// collapse组件默认展开子级
const activeNames = ref(["baseMsg", "materiel", "sign"]);

// 文件上传ref
const uploadRef = ref(null);

// 供应商选中
const selectIndex = ref(null);

//厂站数据
const factoryStationList = ref([]);

//申请人
const userName = ref(null);
// 页面
const printContent = ref(null);

//厂站树
const defaultProps = {
  children: "children",
  label: "organizationName",
};

//获取厂站
const getFactoryStation = () => {
  getFactoryStationList().then((res) => {
    factoryStationList.value = res.data;
  });
};

//切换工程来源获取工程名称下拉
const changeResType = (val, isInit) => {
  if (val == 1) {
    queryProjectList().then((res) => {
      formData.value.thirdResourceType = "1";
      thirdResourceList.value = res.data;
    });
  } else if (val == 3) {
    queryInstallList().then((res) => {
      formData.value.thirdResourceType = "3";
      thirdResourceList.value = res.data;
    });
  }
  // 初始话的时候不清空 工程名称/工程编号数据
  if (!isInit) {
    formData.value.thirdResourceId = null;
    formData.value.thirdResourceRef = null;
    formData.value.thirdResourceName = null;
  }
};
const changeResName = (val) => {
  let data = thirdResourceList.value.find((item) => item.id == val);
  formData.value.thirdResourceRef = data.ref;
  formData.value.thirdResourceName = data.name;
};

// 表单数据
const formData = ref({
  number: null,
  type: null,
  // warehouseId: null,
  boundTime: null,
  boundUser: null,
  remark: null,
  requestDepartmentId: null,
  departmentHeadId: null,
  useTime: null,
  id: null,
  thirdResourceId: null,
  thirdResourceType: null,
  thirdResourceTypeDesc: null,
  thirdResourceRef: null,
  boundUserName: null,
  departmentHeadText: null,
  requestDepartmentText: null,
  thirdResourceCode: null,
  typeText: null,
  deliverySign: null,
  boundSign: null,
  repairRemark: null,
  thirdResourceName: null,
});

// 描述列表
const descriptionList = ref([
  {
    label: "申请单号",
    value: "number",
  },
  {
    label: "申请人",
    value: "boundUserName",
  },
  {
    label: "申请时间",
    value: "boundTime",
  },
  {
    label: "申请部门",
    value: "requestDepartmentText",
  },
  {
    label: "部门负责人",
    value: "departmentHeadText",
  },
  {
    label: "工程类型",
    value: "projectTypeName",
  },
  {
    label: "物料用途",
    value: "typeText",
  },
  {
    label: "工程来源",
    value: "thirdResourceTypeDesc",
    show: (formData) => formData.type == 2,
  },
  {
    label: "工程名称",
    value: "thirdResourceName",
    show: (formData) => formData.type == 2,
  },
  {
    label: "工程编号",
    value: "thirdResourceRef",
    show: (formData) => formData.type == 2,
  },
  {
    label: "厂站名称",
    value: "authOrganizationalDTO.organizationName",
    show: (formData) => formData.type == 3,
  },
  {
    label: "申请人签名",
    value: "deliverySign",
  },
  {
    label: "部门负责人签名",
    value: "boundSign",
  },
]);

// 表单校验规则
const rules = reactive({
  // number: [
  //   { required: true, message: "请输入申请单号", trigger: "blur" },
  //   {
  //     pattern: /^[a-zA-Z0-9]+$/,
  //     message: "只能输入英文和数字",
  //     trigger: "blur",
  //   },
  // ],
  type: [{ required: true, message: "请选择申请类型", trigger: "change" }],
  boundUser: [{ required: true, message: "请选择申请人", trigger: "change" }],
  boundTime: [{ required: true, message: "请选择申请时间", trigger: "blur" }],
  danwei: [{ required: true, message: "请输入送货单位", trigger: "blur" }],
  thirdResourceId: [
    { required: true, message: "请选择工程或项目", trigger: "blur" },
  ],
  requestDepartmentId: [
    { required: true, message: "请选择部门", trigger: "blur" },
  ],
  departmentHeadId: [
    { required: true, message: "请选择部门负责人", trigger: "blur" },
  ],
  useTime: [{ required: true, message: "请选择用料时间", trigger: "blur" }],
  boundSign: [{ required: true, message: "请输入申请人签名", trigger: "blur" }],
  deliverySign: [
    { required: true, message: "请输入部门负责人签名", trigger: "blur" },
  ],
});

// 表格列配置
const columns = ref([
  {
    label: "物料名称",
    prop: "materialName",
  },
  {
    label: "物料编号",
    prop: "number",
  },
  {
    label: "品牌",
    prop: "brand",
  },
  {
    label: "规格型号",
    prop: "model",
  },
  {
    label: "单位",
    prop: "unit",
  },
  {
    label: "库存数量",
    prop: "totalQuantity",
  },
  {
    label: "申请数量",
    prop: "applyQuantity",
  },
  {
    label: "备注",
    prop: "remark",
  },
]);

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = config;
  formData.value = {
    number: null,
    type: null,
    // warehouseId: null,
    boundTime: null,
    boundUser: null,
    remark: null,
    requestDepartmentId: null,
    departmentHeadId: null,
    useTime: null,
    id: null,
    thirdResourceId: null,
    thirdResourceType: null,
    thirdResourceTypeDesc: null,
    ref: null,
    boundUserName: null,
    departmentHeadText: null,
    requestDepartmentText: null,
    thirdResourceCode: null,
    typeText: null,
    deliverySign: null,
    boundSign: null,
    projectType: null,
    projectTypeName: null,
    thirdResourceRef: null,
    repairRemark: null,
    thirdResourceName: null,
  };
  ruleRef.value?.resetFields();
  tableData.value = [];

  if (config.type != "0") {
    getDetail(config.row.id);
  }
  userName.value = JSON.parse(
    localStorage.getItem("userInfo")
  ).userInfo.nikeName;
  getOrg();
  getFactoryStation();
  getTypeList();
  getProjectList();
  buttonLoading.value = false;
  visible.value = true;
};

const defaultPropsOrg = reactive({
  label: "organizationName",
});

//获取组织
const getOrg = () => {
  queryOrganization().then((res) => {
    if (JSON.stringify(res.data) != "{}") {
      orgTree.value = res.data || [];
    }
  });
};

const changeUser = (val) => {};

// 根据id查询详情
const getDetail = (id) => {
  loading.value = true;
  queryDetailById(id)
    .then((res) => {
      for (const key in formData.value) {
        formData.value[key] = res.data[key];
      }
      tableData.value = res.data.materialList;
      if (formData.value.requestDepartmentId) {
        formData.value.requestDepartmentId =
          formData.value.requestDepartmentId.toString();
      }
      if (res.data.type == 2) {
        formData.value.thirdResourceType = res.data.thirdResourceType.value;
        formData.value.thirdResourceTypeDesc = res.data.thirdResourceType.desc;
        formData.value.thirdResourceId = res.data.thirdResourceId;
        formData.value.thirdResourceRef = res.data.thirdResourceRef;
        changeResType(res.data.thirdResourceType.value, true);
      }
      if (res.data.type == 3) {
        formData.value.authOrganizationalDTO = res.data.authOrganizationalDTO;
      }
    })
    .finally(() => {
      previewImg(formData.value.annex, fileList);
      loading.value = false;
    });
};

//点击选择厂站
const handleNodeClick = (val) => {
  formData.value.thirdResourceId = val.id;
  formData.value.thirdResourceType = "STATION";
};

// 點擊保存
const handleSubmit = () => {
  //新增
  if (dialogConfig.value.type == 0) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      if (valid) {
        try {
          const validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          const materialReqs = [...tableData.value];
          materialReqs.map((i) => {
            i.id = null;
          });
          let reqBody = {
            ...formData.value,
            id: null,
            materialReqs,
            boundType: "1",
            boundFileReqs: tableFileData.value,
          };
          addFn(reqBody);
        } catch (e) {
          console.log(e);
        }
      } else {
        buttonLoading.value = false;
      }
    });
  }
  //编辑
  else if (dialogConfig.value.type == 1) {
    buttonLoading.value = true;
    ruleRef.value?.validate((valid) => {
      if (valid) {
        try {
          const validateRes = formValidate();
          if (!validateRes) return (buttonLoading.value = false);
          const materialReqs = [...tableData.value];

          let reqBody = {
            ...formData.value,
            materialReqs,
            boundType: "1",
            boundFileReqs: tableFileData.value,
          };
          editFn(reqBody);
        } catch (e) {
          console.log(e);
        }
      } else {
        buttonLoading.value = false;
      }
    });
  }
};

// 表单提交前校验
const formValidate = () => {
  // 判断是否有选择物料
  if (tableData.value.length == 0) {
    ElMessage.error("未选择任何物料");
    return false;
  }

  // 判断物料列表中的库位和数量是否填充完毕
  const arr = tableData.value.filter((item) => {
    return item.applyQuantity;
  });

  if (arr.length == 0) {
    ElMessage.error("物料数量是必填项");
    return false;
  }

  return true;
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 表格移除
const handleRemove = (index) => {
  tableData.value.splice(index, 1);
};

// 选择物料
const handleMaterielSelect = () => {
  // if (!formData.value.warehouseId) return ElMessage.warning("请先选择申请仓库");
  const ids = [];
  tableData.value.forEach((item) => {
    ids.push(item.materialId);
  });
  selectRef.value?.handleDialogOpen(ids);
};

// 物料选择结束回调
const materielSelectDone = (val) => {
  // 创建一个Set用来存储val数组中的number
  let numbersInTable = new Set(tableData.value.map((item) => item.number));

  // 遍历val数组，将不在table数组中的对象加入table数组
  val.forEach((item) => {
    if (!numbersInTable.has(item.number)) {
      item.id = "";
      tableData.value.push({
        ...item,
        materialName: item.name,
      });
      numbersInTable.add(item.number);
    }
  });
};

// 选择供应商
const handleSupplierSelect = (index) => {
  selectIndex.value = index;
  supplierSelectRef.value?.handleDialogOpen();
};

// 选择项目
const handleProjectSelect = () => {
  projectSelectRef.value?.handleDialogOpen();
};

// 供应商选择结束回调
const supplierSelectionDone = (val) => {
  tableData.value[selectIndex.value].supplier = val.name;
  tableData.value[selectIndex.value].supplierId = val.id;
};

// 项目选择结束回调
const ProjectSelectionDone = (val) => {
  formData.value.thirdResourceId = val.id;
  formData.value.thirdResourceId = val.name;
  formData.value.thirdResourceRef = val.ref;
  formData.value.thirdResourceType = "ENGINEERING_PROJECT";
};

// 新增申请
const addFn = (req) => {
  saveAcceptMaterialV164(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("操作成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .catch((err) => {
      buttonLoading.value = false;
    });
};

// 编辑申请
const editFn = (req) => {
  updateAcceptMaterialV164(req)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("操作成功");
        emits("afterSave");
        visible.value = false;
      }
    })
    .catch((err) => {
      buttonLoading.value = false;
    });
};

// 获取申请类型列表
const getTypeList = () => {
  queryDictList(DICT_KEY["boundAcceptMaterial"]).then((res) => {
    typeList.value = res.data || [];
  });
};

// 获取工程类型列表
const projectList = ref([]);
const getProjectList = () => {
  queryDictList(DICT_KEY["storeroom_project_type"]).then((res) => {
    projectList.value = res.data || [];
  });
};

//申请类型变化
const changeType = (val) => {
  formData.value.thirdResourceId = null;
  formData.value.thirdResourceName = null;
  formData.value.thirdResourceRef = null;
  formData.value.thirdResourceType = null;

  thirdResourceList.value = [];
};

// 获取库位列表
const getLocationList = (id) => {
  queryStashById(id).then((res) => {
    locationList.value = res.data.warehousePositionList || [];
  });
};

// 仓库变化
const warehouseChanged = (val) => {
  tableData.value = [];
  locationList.value = [];
  if (val) getLocationList(val);
};

//  文件预览
const previewImg = (fields, target) => {
  let result;
  if (!fields) return (target.value = null);
  axios
    .post(
      "/api/storeroom/file/preview",
      {
        reduceUrl: fields,
      },
      { responseType: "arraybuffer" }
    )
    .then((res) => {
      let url = "";
      const bytes = new Uint8Array(res.data);
      let len = bytes.length;
      for (let i = 0; i < len; i++) {
        url += String.fromCharCode(bytes[i]);
      }
      result = "data:image/jpg;base64," + window.btoa(url);
    })
    .finally(() => {
      target.value = result;
    });
};

// 获取供应商列表
const getSupplierList = () => {
  querySupplierList({
    page: 1,
    limit: 9999,
    status: "1",
  }).then((res) => {
    supplierList.value = res.data.records;
  });
};

const print = () => {
  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // const originalContents = document.body.innerHTML;
  // hiddenPrintCo;
  // document.body.innerHTML = printContents;
  // window.print();
  // document.body.innerHTML = originalContents;

  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // document.body.innerHTML = printContents;
  // window.print();
  // window.location.reload();

  Print("#printBox", {
    noPrint: ".no-print",
  });

  // const printContents = document?.getElementById("printBox")?.innerHTML;
  // const printContainer = document?.getElementById("hiddenPrintContainer");
  // printContainer.innerHTML = printContents;
  // let printWindow = window.open("", "_blank");
  // printWindow.document.body.innerHTML = printContainer.innerHTML;
  // printWindow.print();
};

// 暴露函数给父组件
defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.mt10 {
  margin-top: 5px;
}
.flex-center {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
